module.exports = __webpack_public_path__ + "images/FUSA_icons/098-basketball.e623587ee79a01ff1a74688dfb548025.svg";